import { PATH_MAP } from '@constants/header';
import { RoutePath } from '@constants/routes';

export const getHeaderTitleKey = (pathname, account) => {
    if (pathname.includes(RoutePath.ResetPassword)) return 'Header.resetPassword';
    if (pathname.includes(RoutePath.VerifyEmail)) return 'Header.verifyEmail';
    if (pathname.includes(RoutePath.AcceptInvitation)) return 'Header.acceptInvitation';

    if (pathname === RoutePath.Surveys && account?.surveysEnabled === false) {
        return 'Sidebar.surveysQrOnly';
    }

    const pathKey = PATH_MAP[pathname];
    return pathKey ? `Header.${pathKey}` : '';
};
